<template>
  <v-container id="bid-register" fluid tag="section">
    <v-row justify="center">
      <v-col cols="12" md="10">
        <idc-component-bid-register :can-create="canCreate" />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  import Vue from 'vue'

  export default Vue.extend({
    name: 'DashboardBidRegister',
    components: {
      IdcComponentBidRegister: () => import('@/components/idc/bids/Register'),
    },
    props: {
      canCreate: {
        type: Boolean,
        default: () => true,
      },
    },
  })
</script>

<style lang="sass">
  section#bid-register
    .v-card--material
      &__heading.success
        background-color: $dark-red-colour !important
        border-color: $dark-red-colour !important
</style>
